export function formatLocalDate(utcDateString: string): string {
    try {
        const date = new Date(utcDateString.endsWith('Z') ? utcDateString : utcDateString + 'Z');
        const localDateString = date.toLocaleString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        });
        return localDateString;
    } catch (error) {
        console.error('Error formatting date:', utcDateString, error);
        return utcDateString;
    }
};